module.exports = __webpack_public_path__ + "img/hr-red-asterisk-19.bb5dd130.png";